import React from 'react';
import './WishListMessage.scss';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';
// import { PickRegistryModal } from './PickRegistryModal';

import loadable from '@loadable/component';
const PickRegistryModal = loadable(() => import(/* webpackChunkName: "pickRegistryModal" */ './PickRegistryModal'));

export class WishListMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clicksToClose: 0,
      showAlertMessage: true,
      showSuccessMessage: true,
    };
  }

  componentDidUpdate = () => {
    if (window.Modernizr && Modernizr.sessionstorage && location.href.indexOf('krypto') > -1) {
      if (sessionStorage.getItem('wlAttempt') && this.props.passedFunctions.parentState.wlResponse) {
        sessionStorage.removeItem('wlAttempt');
        $('html, body').animate(
          {
            scrollTop: $('.wishListMessage').offset().top - 500,
          },
          800
        );
      }
    }
    this.closeMessages();
    if ($('.wishListMessage.success').length > 0 && $('.ReactModal__Overlay').length > 0) {
      $('.ReactModal__Overlay, .qv-scrollable ').scrollTop($('.ReactModal__Overlay')[0].scrollHeight);
    }
  };

  closeMessages = () => {
    if (this.state.clicksToClose == 2) {
      this.props.passedFunctions.closeWishListMessage();
      this.setState({
        clicksToClose: 0,
        showAlertMessage: true,
        showSuccessMessage: true,
      });
    }
  };

  closeAlertMessage = () => {
    this.setState({
      clicksToClose: this.state.clicksToClose + 1,
      showAlertMessage: false,
    });
  };

  closeSuccessMessage = () => {
    if (
      this.props.passedFunctions.parentState.wlResponse.wlInventoryStatus == 'LQTY' ||
      this.props.passedFunctions.parentState.wlResponse.wlInventoryStatus == 'QTY2' ||
      this.props.passedFunctions.parentState.wlResponse.wlInventoryStatus == 'QTY3'
    ) {
      this.setState({
        clicksToClose: this.state.clicksToClose + 1,
        showSuccessMessage: false,
      });
    } else {
      this.props.passedFunctions.closeWishListMessage();
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.props.passedFunctions.parentState.wlResponse &&
        this.props.passedFunctions.parentState.wlResponse.fromMFB ? (
          <React.Fragment>
            {this.props.passedFunctions.parentState.wlResponse.JSON.status &&
            this.props.passedFunctions.parentState.wlResponse.JSON.status[0] != 'noChanges' ? (
              <React.Fragment>
                {this.props.passedFunctions.parentState.wlResponse.JSON.status[0] == 'add' ? (
                  <div className='wishListMessage success'>
                    <button
                      type='button'
                      className='close closeWishListMessage'
                      onClick={this.props.passedFunctions.closeWishListMessage}
                    >
                      <CloseXIcon />
                    </button>
                    Great! This brand has been added. <br />
                    <a className='wlLink' href='/my-preferences'>
                      Click here
                    </a>{' '}
                    to manage your preferred brands.
                  </div>
                ) : (
                  <React.Fragment>
                    {this.props.passedFunctions.parentState.wlResponse.JSON.status[0] == 'remove' ? (
                      <div className='wishListMessage success'>
                        <button
                          type='button'
                          className='close closeWishListMessage'
                          onClick={this.props.passedFunctions.closeWishListMessage}
                        >
                          <CloseXIcon />
                        </button>
                        This brand has been removed. <br />
                        <a className='wlLink' href='/my-preferences'>
                          Click here
                        </a>{' '}
                        to manage your preferred brands.
                      </div>
                    ) : (
                      <div className='wishListMessage alert'>
                        <button
                          type='button'
                          className='close closeWishListMessage'
                          onClick={this.props.passedFunctions.closeWishListMessage}
                        >
                          <CloseXIcon />
                        </button>
                        The max number of brands have been selected. <br />
                        <a className='wlLinkAlert' href='/my-preferences'>
                          Click here
                        </a>{' '}
                        to manage your preferred brands.
                      </div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            ) : (
              ''
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {this.props.passedFunctions.parentState.wlResponse &&
            !this.props.passedFunctions.parentState.wlResponse.registryAdd &&
            !this.props.passedFunctions.parentState.wlResponse.error ? (
              <React.Fragment>
                {this.props.passedFunctions.parentState.wlResponse ? (
                  <React.Fragment>
                    {this.props.passedFunctions.parentState.wlResponse.result == 'success' ? (
                      <React.Fragment>
                        <div className={`wishListMessage success ${!this.state.showSuccessMessage ? 'hidden' : ''}`}>
                          <button
                            type='button'
                            className='close closeWishListMessage'
                            onClick={this.closeSuccessMessage}
                          >
                            <CloseXIcon />
                          </button>
                          This item was added to your wish list. <br />
                          <a
                            className='wlLink'
                            href='/webapp/wcs/stores/servlet/InterestItemDisplay?storeId=301&catalogId=301&langId=-1&orderId=.'
                          >
                            Click here
                          </a>{' '}
                          to view your wish list.
                        </div>

                        {this.props.passedFunctions.parentState.wlResponse.wlInventoryStatus == 'LQTY' ? (
                          <div className={`wishListMessage alert ${!this.state.showAlertMessage ? 'hidden' : ''}`}>
                            <button
                              type='button'
                              className='close closeWishListAlertMessage'
                              onClick={this.closeAlertMessage}
                            >
                              <CloseXIcon />
                            </button>
                            There is only 1 left! <br />
                            <a
                              className='wlLinkAlert'
                              href={`/webapp/wcs/stores/servlet/InterestItemDelete?catEntryId=${this.props.passedFunctions.parentState.wlResponse.wlCatentryToAdd}&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&calculationUsageId=-2&quantity=1&errorViewName=OrderItemDisplayView&URL=OrderItemAdd%3Fak%3Dn%26URL%3DOrderItemDisplay%26addFromCart%3Dtrue%26catEntryId%3D${this.props.passedFunctions.parentState.wlResponse.wlCatentryToAdd}%26field2%3D${this.props.passedFunctions.parentState.wlResponse.field3}%26storeId%3D301%26catalogId%3D301%26langId%3D-1`}
                            >
                              Click here
                            </a>{' '}
                            to add it to your bag.
                          </div>
                        ) : (
                          ''
                        )}

                        {this.props.passedFunctions.parentState.wlResponse.wlInventoryStatus == 'QTY2' ? (
                          <div className={`wishListMessage alert ${!this.state.showAlertMessage ? 'hidden' : ''}`}>
                            <button
                              type='button'
                              className='close closeWishListAlertMessage'
                              onClick={this.closeAlertMessage}
                            >
                              <CloseXIcon />
                            </button>
                            There are only 2 left! <br />
                            <a
                              className='wlLinkAlert'
                              href={`/webapp/wcs/stores/servlet/InterestItemDelete?catEntryId=${this.props.passedFunctions.parentState.wlResponse.wlCatentryToAdd}&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&calculationUsageId=-2&quantity=1&errorViewName=OrderItemDisplayView&URL=OrderItemAdd%3Fak%3Dn%26URL%3DOrderItemDisplay%26addFromCart%3Dtrue%26catEntryId%3D${this.props.passedFunctions.parentState.wlResponse.wlCatentryToAdd}%26field2%3D${this.props.passedFunctions.parentState.wlResponse.field3}%26storeId%3D301%26catalogId%3D301%26langId%3D-1`}
                            >
                              Click here
                            </a>{' '}
                            to add it to your bag.
                          </div>
                        ) : (
                          ''
                        )}

                        {this.props.passedFunctions.parentState.wlResponse.wlInventoryStatus == 'QTY3' ? (
                          <div className={`wishListMessage alert ${!this.state.showAlertMessage ? 'hidden' : ''}`}>
                            <button
                              type='button'
                              className='close closeWishListAlertMessage'
                              onClick={this.closeAlertMessage}
                            >
                              <CloseXIcon />
                            </button>
                            There are only 3 left! <br />
                            <a
                              className='wlLinkAlert'
                              href={`/webapp/wcs/stores/servlet/InterestItemDelete?catEntryId=${this.props.passedFunctions.parentState.wlResponse.wlCatentryToAdd}&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&calculationUsageId=-2&quantity=1&errorViewName=OrderItemDisplayView&URL=OrderItemAdd%3Fak%3Dn%26URL%3DOrderItemDisplay%26addFromCart%3Dtrue%26catEntryId%3D${this.props.passedFunctions.parentState.wlResponse.wlCatentryToAdd}%26field2%3D${this.props.passedFunctions.parentState.wlResponse.field3}%26storeId%3D301%26catalogId%3D301%26langId%3D-1`}
                            >
                              Click here
                            </a>{' '}
                            to add it to your bag.
                          </div>
                        ) : (
                          ''
                        )}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {this.props.passedFunctions.parentState.wlResponse.wishlistLimitReached == 'true' ? (
                          <div className='wishListMessage alert'>
                            <button
                              type='button'
                              className='close closeWishListAlertMessage'
                              onClick={this.props.passedFunctions.closeWishListMessage}
                            >
                              <CloseXIcon />
                            </button>
                            You have reached the limit of items in your wishlist. <br />
                            <a
                              className='wlLinkAlert'
                              href='/webapp/wcs/stores/servlet/InterestItemDisplay?storeId=301&catalogId=301&langId=-1&orderId=.'
                            >
                              Click here
                            </a>{' '}
                            to view your wish list.
                          </div>
                        ) : (
                          <div className='wishListMessage alert'>
                            <button
                              type='button'
                              className='close closeWishListAlertMessage'
                              onClick={this.props.passedFunctions.closeWishListMessage}
                            >
                              <CloseXIcon />
                            </button>
                            There was an error adding this item to your wish list. Please try again later.
                          </div>
                        )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ) : (
                  ''
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {this.props.passedFunctions.parentState.wlResponse &&
                this.props.passedFunctions.parentState.wlResponse.error ? (
                  <div className='wishListMessage alert'>
                    <button
                      className='close closeWishListAlertMessage btn-tertiary'
                      onClick={this.props.passedFunctions.closeWishListMessage}
                      type='button'
                    >
                      <CloseXIcon />
                    </button>
                    {this.props.passedFunctions.parentState.wlResponse.error}
                  </div>
                ) : (
                  ''
                )}

                {this.props.passedFunctions.parentState.wlResponse &&
                this.props.passedFunctions.parentState.wlResponse.registryResponse &&
                !this.props.passedFunctions.parentState.wlResponse.error ? (
                  <div className='wishListMessage success'>
                    <button
                      className='close closeWishListAlertMessage btn-tertiary'
                      onClick={this.props.passedFunctions.closeWishListMessage}
                      type='button'
                    >
                      <CloseXIcon />
                    </button>
                    This item was added to your registry.
                    <br />{' '}
                    <a className='wlLink' href={this.props.passedFunctions.parentState.wlResponse.manageRegistryURL}>
                      Click here
                    </a>{' '}
                    to manage your registry
                  </div>
                ) : (
                  ''
                )}

                {this.props.passedFunctions.parentState.wlResponse &&
                this.props.passedFunctions.parentState.wlResponse.modalType &&
                this.props.passedFunctions.parentState.wlResponse.modalType == 'PickRegistryModal' ? (
                  <PickRegistryModal
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                    modalInfo={this.props.passedFunctions.parentState.wlResponse}
                    ajaxAddToRegistry={this.props.passedFunctions.ajaxAddToRegistry}
                    handleCloseModal={this.props.passedFunctions.closeWishListMessage}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
